// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

/**
 * What the hole is drawn on.
 *
 * `satellite` is the imagery alone, and is the fallback where nothing else applies: it is
 * the only layer nothing was inferred from. `hazards` keeps the imagery and outlines the
 * mapped bunkers, water and green over it, so the boundaries can be read against the ground
 * they claim to describe. `drawing` throws the imagery away and paints the boundaries flat,
 * like a yardage book — legible on a phone in sunlight, and honest that it is a sketch
 * rather than a photograph.
 *
 * Its own module rather than living in {@link HoleViewModal}: the persisted preference store
 * needs the type too, and a store importing it from the component it feeds would be circular.
 */
export type HoleBasemap = 'satellite' | 'hazards' | 'drawing';

export const BASEMAPS: HoleBasemap[] = ['satellite', 'hazards', 'drawing'];

/** What a player who has never chosen sees. */
export const DEFAULT_BASEMAP: HoleBasemap = 'satellite';
